import { useTranslation } from "react-i18next";
import {
  Box,
  Container,
  Stack,
  Text,
  Divider,
} from "@chakra-ui/react";

export default function Footer() {
  const colors = {
    black: "#000000",
    pink: "#e10ea5",
    yellow: "#d3c615",
    red: "#f21d1b",
    orangeRed: "#f31f1c",
    teal: "#1da179",
    green1: "#1b9872",
    green2: "#1d9e77",
  };
  const { t } = useTranslation();

  return (
    <Box bg={colors.teal} color="white" py={8}>
      <Container maxW="7xl">
        <Stack spacing={4} align="center" textAlign="center">
          {/* Copyright */}
          <Text fontSize={{ base: "sm", md: "md" }}>
            {t("footer.rights", "All rights reserved © Active Polymers")}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
